const home = {
  heroTitle: "海量高清视频，免费在线观看",
  heroSubtitle: "电影、电视剧、综艺、动漫、纪录片... 应有尽有，无需下载，即点即播",
  heroCTA: "立即开始观看",
  hotToday: "今日热播",
  weeklyChart: "本周排行",
  newArrivals: "新片上线",
  categoryTitle: "视频分类",
  featureTitle: "特色专题",
  faqTitle: "常见问题",
  statsVideos: "视频资源",
  statsUsers: "活跃用户",
  statsCategories: "内容分类",
  statsDaily: "日更新量",
};

export default home;